module.exports = __webpack_public_path__ + "img/NFC.5a68b791.jpg";